import React from 'react';

import MobileDataTableCard from '../../../../../DataTables/MobileDataTableCard';
import AdvancedDataTable from '../../../../../DataTables/AdvancedDataTable';
import getFormattedNumberWithComma from '../../../../../../utils/getFormattedNumberWithComma';

export default function QuarterbackCollegeBasicPassingStatsTable(props) {
	return (
		<div>
			<div className="text-xl py-2">
				<h4>{props.title}</h4>
			</div>
			<div className="contents lg:hidden">
				<MobileDataTableCard
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					rowRenderer={(row) => {
						const labels = [
							{
								displayName: 'Category',
								apiName: 'category',
								alignment: 'left'
							},
							{
								displayName: 'Games Played',
								apiName: 'college_games_played',
								alignment: 'left'
							},
							{
								displayName: 'Completions',
								apiName: 'college_pass_completions',
								alignment: 'left'
							},
							{
								displayName: 'Attempts',
								apiName: 'college_pass_attempts',
								alignment: 'left'
							},
							{
								displayName: 'Comp %',
								apiName: 'college_pass_completion_percentage',
								alignment: 'left'
							},
							{
								displayName: 'Passing Yards',
								apiName: 'college_passing_yards',
								alignment: 'left'
							},
							{
								displayName: 'Passing TDs',
								apiName: 'college_passing_touchdowns',
								alignment: 'left'
							},
							{
								displayName: 'INTs',
								apiName: 'college_interceptions',
								alignment: 'left'
							}
						];
						return (
							<div
								key={`${row.first_name} ${row.last_name} - PlayersProfileStatsTable - MobileDataTableCard`}
								className="p-5 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
							>
								<div className="flex flex-wrap">
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[1].displayName}
									</div>
									<div className="w-1/2 mb-2">{row.college_games_played}</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[2].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{getFormattedNumberWithComma(row.college_pass_completions)}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[3].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{getFormattedNumberWithComma(row.college_pass_attempts)}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[4].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_pass_completion_percentage}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[5].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{getFormattedNumberWithComma(row.college_passing_yards)}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[6].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_passing_touchdowns}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '150px' }}
									>
										{labels[7].displayName}
									</div>
									<div className="w-1/2">{row.college_interceptions}</div>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					columns={[
						{
							displayName: 'Category',
							apiName: 'category',
							alignment: 'left'
						},
						{
							displayName: 'Games Played',
							apiName: 'college_games_played',
							alignment: 'left'
						},
						{
							displayName: 'Completions',
							apiName: 'college_pass_completions',
							alignment: 'left'
						},
						{
							displayName: 'Attempts',
							apiName: 'college_pass_attempts',
							alignment: 'left'
						},
						{
							displayName: 'Comp %',
							apiName: 'college_pass_completion_percentage',
							alignment: 'left'
						},
						{
							displayName: 'Passing Yards',
							apiName: 'college_passing_yards',
							alignment: 'left'
						},
						{
							displayName: 'Passing TDs',
							apiName: 'college_passing_touchdowns',
							alignment: 'left'
						},
						{
							displayName: 'INTs',
							apiName: 'college_interceptions',
							alignment: 'left'
						}
					]}
					rowRenderer={(row) => {
						return (
							<tr key={row.id} className="bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text">
								<td className="pl-8 py-3 text-left sticky left-0 bg-white dark:bg-dark-card z-10 text-gray-800 dark:text-dark-text">
									Career
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_games_played}
								</td>
								<td className="pl-8 py-3 text-left">
									{getFormattedNumberWithComma(row.college_pass_completions)}
								</td>
								<td className="pl-8 py-3 text-left">
									{getFormattedNumberWithComma(row.college_pass_attempts)}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_pass_completion_percentage}
								</td>
								<td className="pl-8 py-3 text-left">
									{getFormattedNumberWithComma(row.college_passing_yards)}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_passing_touchdowns}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_interceptions}
								</td>
							</tr>
						);
					}}
				/>
			</div>
		</div>
	);
}
